import React, { useEffect } from 'react';
import { useAppStore } from './store/appStore';
import LandingPage from './components/LandingPage';
import ProjectTimeline from './components/ProjectTimeline';
import AITimeline from './components/AITimeline';
import RelationshipNetwork from './components/RelationshipNetwork';
import SummaryPage from './components/SummaryPage';
import Navigation from './components/Navigation';
import AudioControl from './components/AudioControl';
import ParticlesBackground from './components/ParticlesBackground';
import IntroVideo from './components/IntroVideo';
import { AnimatePresence } from 'framer-motion';

const App = () => {
  const { currentPage, showIntroVideo } = useAppStore();

  useEffect(() => {
    console.log('App render - showIntroVideo:', showIntroVideo, 'currentPage:', currentPage, 'at', new Date().toISOString());
  }, [showIntroVideo, currentPage]);

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'landing':
        return <LandingPage />;
      case 'project':
        return <ProjectTimeline />;
      case 'ai':
        return <AITimeline />;
      case 'network':
        return <RelationshipNetwork />;
      case 'summary':
        return <SummaryPage />;
      default:
        return <LandingPage />;
    }
  };

  return (
    <div className="app">
      <AnimatePresence>
        {showIntroVideo && <IntroVideo key="intro-video" />}
      </AnimatePresence>
      <ParticlesBackground />
      {renderCurrentPage()}
      <Navigation />
      <AudioControl />
    </div>
  );
};

export default App;
